module.exports = __webpack_public_path__ + "img/ics_o_info_circle_gray.91856147.svg";